import { Link } from "react-router-dom";
import { Crown, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { trackEvent } from "@/hooks/useArticleAnalytics";

/* Right-rail module 5 (§33-34): NewsLayer Premium — state-aware CTA. */
export const PremiumRailCard = () => {
  const { user } = useAuth();
  const isPremium = !!user?.is_premium;
  const cta = isPremium
    ? { label: "Explore Premium Research", to: "/research" }
    : { label: "Go Premium", to: "/premium" };

  return (
    <section data-testid="premium-rail-card" data-track="premium_rail"
      className="relative overflow-hidden rounded-xl border border-[#7C3AED]/40 bg-gradient-to-br from-[#150c26] to-[#0a0b10] p-4">
      <span aria-hidden className="pointer-events-none absolute -top-12 -right-12 h-32 w-32 rounded-full bg-[#7C3AED]/[0.14] blur-2xl" />
      <p className="flex items-center gap-1.5 font-mono text-[9px] font-bold uppercase tracking-[0.28em] text-[#A78BFA]">
        <Crown className="h-3 w-3" aria-hidden /> NewsLayer Premium
      </p>
      <h3 className="mt-2.5 font-news font-black text-white text-[19px] leading-tight">
        Unlock deeper intelligence.
      </h3>
      <p className="mt-1.5 text-[12.5px] text-gray-400 leading-relaxed">
        Ad-free reading, exclusive research, and real-time onchain insights.
      </p>
      <Link to={cta.to} data-testid="premium-rail-cta"
        onClick={() => trackEvent("premium_rail_click", { premium: isPremium })}
        className="mt-4 flex items-center justify-center gap-2 rounded-md bg-[#7C3AED] hover:bg-[#8B5CF6] text-white text-[13px] font-bold px-3.5 py-2.5 transition-colors">
        {cta.label} <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </section>
  );
};
